import { useEffect } from "react";
import { HISTORY_STORAGE_KEY } from "../../config/constants";
import useCommandFlowStore from "../../store/commandFlowStore";

export const useResetCommandHistory = () => {
  const resetToken = useCommandFlowStore((state) => state.resetToken);
  const setHistory = useCommandFlowStore((state) => state.setHistory);

  useEffect(() => {
    if (resetToken > 0) {
      setHistory([]);
      if (typeof window !== "undefined") {
        localStorage.removeItem(HISTORY_STORAGE_KEY);
      }
    }
  }, [resetToken, setHistory]);
};
